module.exports = __webpack_public_path__ + "static/media/Cooked_Red_Cap.0515999b.webp";